<script>
  import { fade } from "svelte/transition";
  import Load from "../components/Load.svelte";
  import Alert from "../components/Alert.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";

  //liblary
  import axios from "axios";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = [];
  let items = [];
  let itemsDisplay = false;
  axios
    .get(settings.url + "/sipade/tagihan", {
      params: {
        authorization: settings.token,
      },
    })
    .then(function (response) {
      items = response.data;
      if (response.data) {
        setTimeout(() => {
          itemsDisplay = true;
        }, 2000);
      }
    })
    .catch(function (error) {
      itemsDisplay = false;
      if (error.response.status == 401) {
        localStorage.removeItem("t");
        redirect("/login");
      } else {
        if (error.response.data.message) {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: error.response.data.message,
              color: "orange",
            },
          ];
        } else {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: "Anda belum terhubung dengan baik",
              color: "orange",
            },
          ];
        }
      }
    })
    .then(function () {
      // always executed
    });

  let uid = Math.random().toString(36).substring(2);
</script>

<svelte:head>
  <title>Tagihan - Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<Navigationbar
  backbtn="true"
  message={navigation["message"]}
  title="Daftar Tagihan"
/>
<main
  transition:fade
  class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0"
>
  <div class="max-w-xl mx-auto my-5 mb-2 text-center md:text-left">
    <h2 class="text-xl">Tagihan</h2>
    <p class="text-sm text-gray-700">
      Periksa dan selesaikan tagihan untuk kamu
    </p>
  </div>
  <div
    class="max-w-xl pt-2 mx-auto my-5 mt-5 bg-white rounded-lg lg:mt-5 md:mt-5 lg:my-0 bg-lg"
  >
    {#if itemsDisplay}
      {#if items.details != null}
        {#if items.details.data}
          {#each items.details.data as d}
            <div
              class="relative flex items-center w-full p-2 transition duration-500 ease-in-out transform border-b border-gray-200 rounded-lg cursor-pointer hover:-translate-y-1 md:space-x-4 dark:hover:bg-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-60 dark:border-gray-600"
            >
              <div
                class="items-center justify-center hidden w-1/6 h-12 bg-gray-200 rounded-lg dark:bg-gray-500 dark:text-white lg:flex md:hidden"
              >
                {d.contact_name.charAt(0)}
              </div>
              <div class="flex flex-col items-start w-3/6 text-sm flex-2">
                <span class="text-xs font-normal">{d.invoice_number} </span>
                <span class="font-bold "
                  >{d.line_items[0].name}
                  {#if d.line_items.length > 1}dan {d.line_items.length} lainnya{/if}</span
                >
                <span class="text-xs font-normal" title="tanggal faktur"
                  >{d.invoiced_at} - {d.due_at}</span
                >
              </div>
              <div class="flex flex-col items-end flex-1 w-2/6 text-sm">
                {#if d.status == "draft"}
                  <span
                    class="px-3 mb-2 text-xs text-white bg-red-500 rounded-full border-full"
                    >Konsep</span
                  >
                {:else if d.status == "waiting"}
                  <span
                    class="px-3 mb-2 text-xs text-white bg-blue-500 rounded-full border-full"
                    >Menunggu</span
                  >
                {:else if d.status == "paid"}
                  <span
                    class="px-3 mb-2 text-xs text-white bg-green-500 rounded-full border-full"
                    >Lunas</span
                  >
                {:else if d.status == "partial"}
                  <span
                    class="px-3 mb-2 text-xs text-white bg-yellow-500 rounded-full border-full"
                    >Sebagian</span
                  >
                {:else if d.status == "overdue"}
                  <span
                    class="px-3 mb-2 text-xs text-white bg-purple-500 rounded-full border-full"
                    >Telat Bayar</span
                  >
                {:else if d.status == "cancel"}
                  <span
                    class="px-3 mb-2 text-xs text-white bg-gray-500 rounded-full border-full"
                    >Dibatalkan</span
                  >{/if}
                <span
                  class="px-3 mb-2 text-xs text-blue-900 bg-gray-200 rounded-full dark:bg-gray-500 dark:text-white border-full"
                  >{d.amount}</span
                >
              </div>
            </div>
          {:else}
            <div class="w-full px-2 mx-auto">
              <div class="w-full p-10 bg-white rounded-lg shadow-lg">
                <div class="my-6 text-center">
                  <h2 class="text-2xl">Belum ada tagihan</h2>
                  <p class="pb-5 text-gray-500">
                    saat ini belum ada tagihan untuk kamu
                  </p>
                  <a
                    href="./belanja"
                    class="px-10 py-2 text-xl text-white bg-blue-400 rounded-lg"
                    >Belanja Yuks</a
                  >
                </div>
              </div>
            </div>
          {/each}
        {:else}
          <div class="w-full px-2 mx-auto">
            <div class="w-full p-10 bg-white rounded-lg shadow-lg">
              <div class="my-6 text-center">
                <h2 class="text-2xl">Belum ada tagihan</h2>
                <p class="pb-5 text-gray-500">
                  saat ini belum ada tagihan untuk kamu
                </p>
                <a
                  href="./belanja"
                  class="px-10 py-2 text-xl text-white bg-blue-400 rounded-lg"
                  >Belanja Yuks</a
                >
              </div>
            </div>
          </div>
        {/if}
      {:else}
        <div class="w-full px-2 mx-auto">
          <div class="w-full p-10 bg-white rounded-lg shadow-lg">
            <div class="my-6 text-center">
              <h2 class="text-2xl">Belum ada tagihan</h2>
              <p class="pb-5 text-gray-500">
                saat ini belum ada tagihan untuk kamu
              </p>
              <a
                href="./belanja"
                class="px-10 py-2 text-xl text-white bg-blue-400 rounded-lg"
                >Belanja Yuks</a
              >
            </div>
          </div>
        </div>
      {/if}
    {:else}
      <Load />
    {/if}
  </div>
</main>
